import { BaseService } from "./base.service";
export class ProgramTemplateCriteriaService extends BaseService {
  constructor() {
    super("program-template-criteria");
  }
}
